<section class="ssl-certificate-loading-container">
  <div class="title">Generating your free SSL certificate</div>
  <div class="subtitle">This process may take up to 1 minute.<br> Please do not close this window or refresh the page.</div>
  <div class="actions">
    <div class="loading-btn">
      <img src="assets/images/loading/spinner-dotted.svg">
    </div>
  </div>
</section>
